export default function CedarRapidsComparisonSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Compare Options</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Cedar Rapids Passport Options Compared
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            See how Fast Passport Center compares to the standard post office route for Cedar Rapids travelers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <h3 className="font-bold text-[#1A365D] text-base mb-4">Post Office / Clerk</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>6–13 weeks processing</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>Appointment required</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>No tracking or updates</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>Self-guided process</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>No expedited guarantee</span>
              </div>
            </div>
            <p className="text-gray-400 text-xs mt-4 pt-4 border-t border-gray-100">Best for budget-conscious travelers with 4+ months before travel.</p>
          </div>

          <div className="bg-white rounded-lg p-6 border-2 border-[#F6C344] relative">
            <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#F6C344] text-[#1A365D] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">Recommended</span>
            <h3 className="font-bold text-[#1A365D] text-base mb-4">Fast Passport Center</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                <span><strong>2–9 days</strong> expedited</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                <span><strong>24–72 hours</strong> emergency</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                <span>Real-time tracking & updates</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                <span>Expert document review</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                <span>Personalized checklist</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                <span>Live human support</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                <span>Registered State Dept. courier</span>
              </div>
            </div>
            <p className="text-gray-400 text-xs mt-4 pt-4 border-t border-gray-100">Best for travelers with trips in 2 weeks to 3 months.</p>
          </div>

          <div className="bg-white rounded-lg p-6 border border-gray-200">
            <h3 className="font-bold text-[#1A365D] text-base mb-4">Regional Agency</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>1–2 days (if approved)</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>Appointment required (hard to get)</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>Must drive to Chicago (5–6 hrs)</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>Life-or-death only</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                <span>No guidance or review</span>
              </div>
            </div>
            <p className="text-gray-400 text-xs mt-4 pt-4 border-t border-gray-100">Best for true emergencies with travel within 72 hours and proof of life-or-death.</p>
          </div>
        </div>
      </div>
    </section>
  );
}